<div class="chat-popup" id="myForm">
  <form action="" class="form-container">
    <div align="right" class="icon_div">
      <span class="cancel" (click)="closeChat()">
        <img class="cross_img" src="/assets/img/tools/close-pv3.png" />
      </span>
    </div>

    <label id="chatMessage">{{ displayMessage }}</label>
    <input
      class=""
      name="reply_email"
      id="reply_email"
      type="text"
      placeholder="Reply email"
      [(ngModel)]="replay_email"
      (change)="onChangeEmail($event)"
    />
    <textarea
      placeholder="Type message.."
      id="email_body"
      name="msg"
      [(ngModel)]="email_body"
      (change)="onChangeEmailBody($event)"
    ></textarea>

    <button
      type="button"
      id="emailFormButton"
      class="btn"
      (click)="sendEmail()"
      [disabled]="
        (email_body && !email_body.trim().length) ||
        !email_body ||
        !replay_email ||
        (replay_email && !replay_email.trim().length)
      "
    >
      Send
    </button>
  </form>
</div>
